import { paths } from "@/app/paths"
import type { RecentSearch } from "@/db"

/** Matches the display cap used by the autocomplete default state. */
export const RECENT_SEARCH_DISPLAY_LIMIT = 3

/**
 * Rows are written over years of route changes: older ones use the deprecated
 * `/property` LDP prefix, and older still are a bare location slug. Normalize
 * both to a path the current router can handle.
 */
export function normalizeRecentSearchLink(link: string): string {
  const withCurrentLdpBase = link.replace(
    paths.legacyLdpPath(),
    paths.baseLdpPath()
  )

  if (
    withCurrentLdpBase.startsWith(paths.srpBase()) ||
    withCurrentLdpBase.startsWith(paths.rentBase()) ||
    withCurrentLdpBase.startsWith(paths.soldBase()) ||
    withCurrentLdpBase.startsWith(paths.baseLdpPath())
  ) {
    return withCurrentLdpBase
  }

  return paths.srpBase() + withCurrentLdpBase
}

/**
 * Newest first, one row per location. The store appends a row on every select,
 * so searching the same city twice would otherwise fill the whole list.
 */
export function dedupeRecentSearches(
  searches: RecentSearch[],
  limit = RECENT_SEARCH_DISPLAY_LIMIT
): RecentSearch[] {
  const byLocation = new Map<string, RecentSearch>()

  for (const search of [...searches].sort((a, b) => b.timestamp - a.timestamp)) {
    const key = `${search.resultDisplayName.toLowerCase()}|${search.categoryName.toLowerCase()}`
    if (!byLocation.has(key)) {
      byLocation.set(key, search)
    }
  }

  return [...byLocation.values()].slice(0, limit)
}
